import { render, staticRenderFns } from "./newinquiry.vue?vue&type=template&id=4b0af846&scoped=true&"
import script from "./newinquiry.vue?vue&type=script&lang=js&"
export * from "./newinquiry.vue?vue&type=script&lang=js&"
import style0 from "./newinquiry.vue?vue&type=style&index=0&id=4b0af846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0af846",
  null
  
)

export default component.exports